module.exports = __webpack_public_path__ + "img/andrew.d35d880f.jpg";